import { FormControl, FormControlLabel, Grid, Switch } from '@mui/material';
import React from 'react';

interface AuthMethodSwitchProps {
	formik: any;
	disabled?: boolean;
}

const AuthMethodSwitch: React.FC<AuthMethodSwitchProps> = ({
	formik,
	disabled
}) => (
	<Grid item xs={12}>
		<FormControl margin="normal" component="fieldset">
			<FormControlLabel
				control={
					<Switch
						data-testid="auth-method-enable-switch"
						id="enabled"
						checked={formik.values.enabled || false}
						onClick={() =>
							formik.setFieldValue('enabled', !formik.values.enabled)
						}
						disabled={disabled}
					/>
				}
				label={intl.tr('authMethods.api.enable')}
			/>
		</FormControl>
	</Grid>
);

AuthMethodSwitch.defaultProps = {
	disabled: false
};
export default AuthMethodSwitch;
